import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@material-ui/core";

import DeleteDialog from "../../modal/DeleteDialog";
import { setDialogHandle } from "../../../actions/dialog";
import {
  PreferenceFormComponent,
  IPreferenceFormComponent,
} from "./PreferenceForm";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import DeleteTitle from "../../../components/modal/DeleteTitle";
import FormTitle from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import { useDispatch } from "react-redux";

import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../const/permissions.const";
import DisabledActionWrapper from "../../../yoello-lib/modules/components/DisabledActionWrapper";

interface Props {
  properties: IPreferenceFormComponent;
}

const DeletePreference = (props: Props) => {
  const { properties } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  const contents = (
    <>
      <p>{t("delete.preferences.content1")}</p>
      <p>{t("delete.preferences.content2")}</p>
    </>
  );


  const disabledMessage = t("delete.preferences.warning");

  const onCancel = () => {
    dispatch(
      setDialogHandle({
        Component: PreferenceFormComponent,
        ComponentProps: properties,
        dialogTitle: t("menu.preferences.title"),
        isFormDialog: true
      })
    );
  };

  const onSubmit = async () => {
    setIsLoading(true);
    await properties.callAPI(HTTPMethods.DELETE, {
      query: properties?.formData?.id,
      params: {
        force: true,
      },
      successCall: t("delete.preferences.success"),
      errorCall: {
        400: t("delete.preferences.failure400"),
        500: t("delete.preferences.failure500"),
      },
    });
    await properties.callAPI(HTTPMethods.GET);
    setIsLoading(false);
    properties.closeAll();
  };

  return (
    <DisabledActionWrapper
      disabled={!hasPermission}
      onDisabledClick={onFailedInteraction}
    >
      <DeleteDialog
        pre={
          <>
            <FormTitle
              title={t("delete.preferences.header")}
              subtitle={t("delete.preferences.description")}
            />
          </>
        }
        onCancel={onCancel}
        onSubmit={onSubmit}
        onClose={onCancel}
        dialogTitle={<DeleteTitle title={t("delete.preferences.title")} />}
        contents={isLoading ? <CircularProgress /> : contents}
        disabledMessage={disabledMessage}
        isDisabled={!hasPermission}
        onDisabledClick={onFailedInteraction}
        buttonText={t("delete.preferences.button")}
        isArrayModal={true}
      />
    </DisabledActionWrapper>
    
  );
};

export default DeletePreference;
